module.exports = __webpack_public_path__ + "img/vertical_7_2_8003.54094bb7.png";